import React, { useCallback } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import { mapCandidateAttachments } from 'features/sendouts/common/utils';
import { Attachments } from 'features/sendouts/components/shared';
import { AttachmentsVariant } from 'features/sendouts/components/shared/Attachments';
import { TabLoaderContainer } from 'features/sendouts/components/shared/DetailsTabs';
import { ATTACHMENTS_CATEGORIES } from 'features/sendouts/constants';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import strings from 'strings';
import {
  CandidateFileCategoriesWithSendout,
  OfferLetterFileCandidateCategoryId
} from 'UI/components/organisms/sendouts/utils';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';
import { Endpoints } from 'UI/constants/endpoints';

import { OfferLetterAttachment } from './components';
import { OfferLetterText, SectionContainer } from './SendoutAttachmentsTabContent.styled';

const ATTACHMENT_CATEGORIES = [
  ATTACHMENTS_CATEGORIES.resume,
  ATTACHMENTS_CATEGORIES.portfolio,
  ATTACHMENTS_CATEGORIES.other
];

export const SendoutAttachmentsTabContent = ({ sendoutId }) => {
  const { Status } = useFetchWithStatusV2({
    endpoint: sendoutId ? `${Endpoints.Sendouts}/${sendoutId}` : null, // TODO: use sendout attachments endpoint when it is available. By now is using legacy sendout details endpoint which includes attachments data.
    apiVersion: 1
  });
  const handleTempOfferLetterUploaded = useCallback(
    async tempFile => {
      // TODO: persist the uploaded temp file as the sendout offer letter once the endpoint is ready.
      // await API.post(`${Endpoints.Sendouts}/${sendoutId}/offer-letter`, {
      //   file_id: tempFile.id
      // });
      // await refreshData(false);
      // eslint-disable-next-line no-console
      console.log('Offer letter temp file uploaded', { sendoutId, tempFile });
      return tempFile;
    },
    [sendoutId]
  );

  return (
    <Status
      loading={
        <TabLoaderContainer>
          <CircularProgress />
        </TabLoaderContainer>
      }
      success={data => {
        const attachments = mapCandidateAttachments(data.attachments);
        const offerLetterFile =
          attachments.find(file => file.file_type_id === OfferLetterFileCandidateCategoryId) ||
          null;

        return (
          <>
            <SectionContainer>
              <Typography variant="subtitle1">
                {strings.sendoutsV2.drawers.tabs.attachments.sendoutFiles}
              </Typography>
              <Attachments
                allowDelete={false}
                categories={ATTACHMENT_CATEGORIES}
                categoryIdMap={CandidateFileCategoriesWithSendout}
                files={attachments}
                variant={AttachmentsVariant.Readonly}
              />
            </SectionContainer>
            <SectionContainer>
              <Typography variant="subtitle1">
                {strings.sendoutsV2.drawers.tabs.attachments.offerLetter.title}
              </Typography>
              <OfferLetterText variant="body2" color="textSecondary">
                {strings.sendoutsV2.drawers.tabs.attachments.offerLetter.description}
              </OfferLetterText>
              <OfferLetterAttachment
                file={offerLetterFile}
                uploadEndpoint={Endpoints.Files}
                onTempFileUploaded={handleTempOfferLetterUploaded}
              />
            </SectionContainer>
          </>
        );
      }}
      error={<EmptyPlaceholder title={strings.sendoutsV2.drawers.tabs.status.error} />}
    />
  );
};
